module.exports = __webpack_public_path__ + "img/t1-10.5a08087e.png";